import { render, staticRenderFns } from "./SendMessageDraftCompose.vue?vue&type=template&id=1fc3f212&"
import script from "./SendMessageDraftCompose.vue?vue&type=script&lang=js&"
export * from "./SendMessageDraftCompose.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageDraftCompose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports